<script>
import classModifierMixin from './mixins/class-modifier-mixin'
export default {
	name: 'BaseSelect',
	mixins: [classModifierMixin],
	inheritAttrs: false,
	props: {
		label: {
			type: [ String, Number ]
		},
		value: {
			type: [ String, Number, Boolean ]
		},
		initialValue: {
			type: [ String, Number, Boolean ],
			default: null
		},
		invalid: {
			type: Boolean,
			default: false
		},
		options: {
			type: Array,
			required: true,
			default: () => []
		},
		placeholderValue: {
			type: String
		},
		readOnly: {
			type: Boolean
		}
	},
	methods: {
		updateValue (event) {
			if (event) this.$emit('input', event.target.value)
		}
	},
	computed: {
		defaultValue: function () {
			if (this.value === null || this.value === undefined) {
				if (this.initialValue) return this.initialValue
				if (this.placeholderValue) return this.placeholderValue
				if (this.options && this.options[0]) return this.options[0].key
				return null
			} else {
				return this.value
			}
		}
	}
}
</script>
<template>
	<div class="base-select" :class="modifierClasses">
		<label :for="label" class="base-select__label" v-if="label">
			{{ label }}
		</label>
		<select class="base-select__input"
				:name="label" @change="updateValue"
				:value="defaultValue" v-bind="$attrs"
				:disabled="readOnly"
				:class="{ 'base-select__input--invalid' : invalid }">
			<option selected disabled v-if="placeholderValue">{{ placeholderValue }}</option>
			<option v-for="option in options" :value="option.key" :key="option.key" :selected="option.key === defaultValue">{{ option.label }}</option>
		</select>
	</div>
</template>
<style lang="scss">
.base-select {
	&__label {
		display: inline-block;
		font-weight: bold;
		margin: 0 0 0.5rem 0;
		font-size: var(--label-font-size);
	}
	&__input {
		font-size: 1.1rem;
		text-overflow: ellipsis;
		background-color:white;
		padding: 0.5rem;
		border: solid 1px var(--border-colour);
		border-radius: 4px;
		height: 2.5rem;
		width: 100%;
		&:disabled {
			background-color:#EEE;
			color:rgb(87,87,87);
		}
		&--invalid {
			background-color: #fff5db;
			border: solid 2px red;
		}
	}

}
</style>
